import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bg-gray-800 p-3 rounded-lg mb-6"
}
const _hoisted_2 = { class: "flex flex-wrap items-center gap-2" }
const _hoisted_3 = { class: "mr-1" }
const _hoisted_4 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.hasActiveFilters)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[2] || (_cache[2] = _createElementVNode("span", { class: "text-gray-400 text-sm font-medium" }, "Aktivni filteri:", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filters, (value, key) => {
            return (_openBlock(), _createElementBlock("div", {
              key: key,
              class: "inline-flex items-center bg-gray-700 text-white text-sm rounded-md px-2 py-1"
            }, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.filterLabels[key]) + ": " + _toDisplayString(_ctx.getFilterDisplayValue(key, value)), 1),
              _createElementVNode("button", {
                onClick: ($event: any) => (_ctx.$emit('remove-filter', key)),
                class: "ml-1 text-gray-400 hover:text-white"
              }, _cache[1] || (_cache[1] = [
                _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  class: "h-4 w-4",
                  viewBox: "0 0 20 20",
                  fill: "currentColor"
                }, [
                  _createElementVNode("path", {
                    "fill-rule": "evenodd",
                    d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                    "clip-rule": "evenodd"
                  })
                ], -1)
              ]), 8, _hoisted_4)
            ]))
          }), 128)),
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('reset-filters'))),
            class: "text-green-500 hover:text-green-400 text-sm font-medium ml-2"
          }, " Očisti sve ")
        ])
      ]))
    : _createCommentVNode("", true)
}